module.exports = __webpack_public_path__ + "static/media/banner.06d49e5a.png";